import React from 'react';
import PropTypes from 'prop-types';
import menuIcon from 'assets/images/icons/menu-grey.svg';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';
import DropdownWrapper from './DropdownWrapper';
import { deleteCustomizedTableHeader, setUserCustomizedTableHeader } from 'actions/ReduxActions';
import FormButton from 'components/form-components/FormButton';
import { isRTL } from 'config/config';

const MoreFieldsDropdownNew = ({
  fieldList,
  setFieldListSelection,
  headerPersistKey,
  resetHeader,
}) => {
  return (
    <div>
      <DropdownWrapper
        style={{}}
        toggleComponent={
          <div
            className='d-flex align-items-center gap-1 cursor-pointer px-2 theme-background-white-5'
            style={{
              minHeight: '3rem',
              border: '1px solid #d9d9d9',
              borderRadius: isRTL() ? '0.75rem 0 0 0' : '0 0.75rem 0 0',
            }}
          >
            <img src={menuIcon} />
            <span>&#x25bc;</span>
          </div>
        }
        dropdownContent={
          <FieldSelectionMenu
            fieldList={fieldList}
            setFieldListSelection={setFieldListSelection}
            headerPersistKey={headerPersistKey}
            resetHeader={resetHeader}
          />
        }
      />
    </div>
  );
};

MoreFieldsDropdownNew.propTypes = {
  fieldList: PropTypes.array.isRequired,
  setFieldListSelection: PropTypes.func.isRequired,
  headerPersistKey: PropTypes.string,
  resetHeader: PropTypes.func,
};

export default MoreFieldsDropdownNew;

const FieldSelectionMenu = ({
  fieldList,
  setFieldListSelection,
  headerPersistKey,
  resetHeader,
}) => {
  const { t } = useTranslation();

  const handleSelected = (field, value) => {
    const currentFieldsSelection = cloneDeep(fieldList);
    const foundIndex = currentFieldsSelection.findIndex((f) => f.name === field);
    currentFieldsSelection[foundIndex].isSelected = value;
    setFieldListSelection(currentFieldsSelection);
    if (headerPersistKey) setUserCustomizedTableHeader(headerPersistKey, currentFieldsSelection);
  };

  const handleReset = () => {
    // delete header from redux
    if (headerPersistKey) deleteCustomizedTableHeader(headerPersistKey);
    if (resetHeader) resetHeader();
  };

  return (
    <div style={{ maxHeight: '48vh', overflow: 'auto' }}>
      {fieldList.map(
        (field, index) =>
          field.name !== '' &&
          field.name.length > 0 &&
          field.displayName && (
            <div
              className='px-3 py-1 d-flex align-items-center gap-2 user-select-none cursor-pointer'
              key={index}
              onClick={() => {
                if (!field.mandatory) {
                  handleSelected(field.name, !field.isSelected);
                }
              }}
            >
              <input
                type='checkbox'
                name={field.name}
                id={field.name}
                disabled={field.mandatory ?? false}
                checked={field.isSelected}
                onChange={() => {}}
                className='form-check-input m-0'
              />
              <span className='width-max-content cursor-pointer'>{t(field.displayName)}</span>
              <span className='px-2'></span>
            </div>
          ),
      )}
      {resetHeader && (
        <FormButton
          text='button_reset_table_header'
          variant='white-1'
          classes='my-2 mx-auto rounded-pill'
          minWidth
          onClick={handleReset}
        />
      )}
    </div>
  );
};

FieldSelectionMenu.propTypes = {
  fieldList: PropTypes.array.isRequired,
  setFieldListSelection: PropTypes.func.isRequired,
  headerPersistKey: PropTypes.string,
  resetHeader: PropTypes.func,
};
